// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BrandsListItem_BrandContainer__V21id {
  perspective: 100px;
}

.BrandsListItem_BrandContainer__V21id img {
  transition: transform 0.5s;
}

.BrandsListItem_BrandContainer__V21id img:hover {
  transform: translateZ(30px);
}
`, "",{"version":3,"sources":["webpack://./src/components/Landing/Welcome/BrandList/BrandListItem/BrandsListItem.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;AAC7B","sourcesContent":[".BrandContainer {\n  perspective: 100px;\n}\n\n.BrandContainer img {\n  transition: transform 0.5s;\n}\n\n.BrandContainer img:hover {\n  transform: translateZ(30px);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"BrandContainer": `BrandsListItem_BrandContainer__V21id`
};
export default ___CSS_LOADER_EXPORT___;
